<p-toast />

<div class="p-4">
  <div class="text-center mb-4">
    <h2 class="text-primary">Tareas del Plan de Acción</h2>
    <p class="text-muted" *ngIf="actionPlan">
      Plan de Acción: <strong>{{ actionPlan.folio }}</strong>
    </p>

    <p class="text-muted" *ngIf="actionPlan?.event">
      Evento: <strong>{{ actionPlan.event.title }}</strong> ({{ actionPlan.event.folio }})
    </p>
  </div>

  <div class="grid mb-4">
    <div class="col-12 lg:col-3 mb-3">
      <div class="card shadow-2 border-round p-3 bg-blue-50">
        <div class="flex justify-content-between align-items-center">
          <div>
            <span class="block text-600 font-medium mb-2">Total de Tareas</span>
            <div class="text-900 font-bold text-3xl">{{ totalTasks }}</div>
            <span class="text-500 text-sm">100%</span>
          </div>

          <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
            style="width:3rem;height:3rem">
            <i class="pi pi-list text-blue-500 text-xl"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-3 mb-3">
      <div class="card shadow-2 border-round p-3 bg-cyan-50">
        <div class="flex justify-content-between align-items-center">
          <div>
            <span class="block text-600 font-medium mb-2">Por Hacer</span>
            <div class="text-900 font-bold text-3xl">{{ tasksTodo }}</div>
            <span class="text-500 text-sm">{{ percentageTodo }}%</span>
          </div>

          <div class="flex align-items-center justify-content-center bg-cyan-100 border-round"
            style="width:3rem;height:3rem">
            <i class="pi pi-clock text-cyan-500 text-xl"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-3 mb-3">
      <div class="card shadow-2 border-round p-3 bg-yellow-50">
        <div class="flex justify-content-between align-items-center">
          <div>
            <span class="block text-600 font-medium mb-2">En Progreso</span>
            <div class="text-900 font-bold text-3xl">{{ tasksInProgress }}</div>
            <span class="text-500 text-sm">{{ percentageInProgress }}%</span>
          </div>

          <div class="flex align-items-center justify-content-center bg-yellow-100 border-round"
            style="width:3rem;height:3rem">
            <i class="pi pi-spin pi-spinner text-yellow-500 text-xl"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-3 mb-3">
      <div class="card shadow-2 border-round p-3 bg-green-50">
        <div class="flex justify-content-between align-items-center">
          <div>
            <span class="block text-600 font-medium mb-2">Completadas</span>
            <div class="text-900 font-bold text-3xl">{{ tasksDone }}</div>
            <span class="text-500 text-sm">{{ percentageDone }}%</span>
          </div>

          <div class="flex align-items-center justify-content-center bg-green-100 border-round"
            style="width:3rem;height:3rem">
            <i class="pi pi-check-circle text-green-500 text-xl"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="totalTasks > 0; else noTasks">
    <h5 class="text-primary mb-3">Lista de Tareas</h5>

    <p-table class="custom-table" styleClass="p-datatable-sm" [value]="tasks" dataKey="id" [loading]="loading"
      [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 20, 30, 50]">
      <ng-template pTemplate="header">
        <tr>
          <th class="bg-gray-100">Folio</th>
          <th class="bg-gray-100">Título</th>
          <th class="bg-gray-100">Cliente</th>
          <th class="bg-gray-100">Responsable</th>
          <th class="bg-gray-100">Usuario</th>
          <th class="bg-gray-100">Fecha Inicial</th>
          <th class="bg-gray-100">Fecha Final</th>
          <th class="bg-gray-100">Estatus</th>
          <th class="bg-gray-100">Acciones</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-task>
        <tr class="text-sm">
          <td>
            <span class="folio">{{ task.folio }}</span>
          </td>
          <td class="table-text">{{ task.title }}</td>
          <td class="table-text">{{ task.customer?.name || 'N/A' }}</td>
          <td>{{ task.task_type?.name || 'N/A' }}</td>
          <td class="table-text">{{ task.user?.name || 'N/A' }}</td>
          <td>{{ task.initial_date | date: 'dd/MM/yyyy' }}</td>
          <td>{{ task.final_date | date: 'dd/MM/yyyy' }}</td>

          <td>
            <span [class]="getStatusClass(task.status) + ' px-2 py-1 border-round'">
              {{ task.status?.name }}
            </span>
          </td>

          <td>
            <p-button (click)="viewTaskDetails(task)" type="button" icon="pi pi-eye"
              styleClass="p-button-rounded p-button-text p-button-sm" pTooltip="Ver detalles" tooltipPosition="top">
            </p-button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" class="text-center">No hay tareas registradas</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template #noTasks>
    <div class="card p-5 text-center no-tasks-container">
      <i class="pi pi-inbox text-400" style="font-size: 3rem;"></i>
      <h3 class="mt-3 text-600">No hay tareas asociadas</h3>
      <p class="text-muted">
        Este plan de acción no tiene tareas registradas aún.
      </p>
    </div>
  </ng-template>

  <div class="button-group mt-4">
    <button (click)="close()" pButton pRipple type="button" label="Cerrar" class="p-button-raised"></button>
  </div>
</div>